import type { SipPlanRecommendationDetails } from '../../api/sipPlanRecommendation.types'
import { planPercentageLabel } from '../../../../display-values/lumpsumPlanPercentage'
import { formatSipCategorySipsLabel } from '../../../../utils/sip/planListUtils'
import {
  PlanRecommendationReasonPointer,
  resolvePlanRecommendationReasonPointerBadgeLabel
} from '../../../../plans-ui-components/PlanRecommendationReasonPointer'

type SipDecreasePlanRecommendationBodyProps = {
  planDetails: SipPlanRecommendationDetails | null
}

export function SipDecreasePlanRecommendationBody({
  planDetails
}: SipDecreasePlanRecommendationBodyProps) {
  const categoryName = (planDetails?.categoryName ?? '').trim() || 'this category'
  const categorySipsLabel = formatSipCategorySipsLabel(planDetails?.categoryName)
  const idealAllocationAbsolute = planDetails?.idealAllocationPercentage?.absolute ?? 0

  return (
    <div>
      <div className="h-[10px] bg-[#F0F4F7]" />
      <div className="pt-6 pb-2">
        <div className="px-5 pb-2 text-[18px] font-[500] leading-[130%] text-[#232323]">
          Reasons to decrease SIP
        </div>
        <div className="pt-4">
          <PlanRecommendationReasonPointer
            index={1}
            badgeLabel={resolvePlanRecommendationReasonPointerBadgeLabel({
              totalPointerCount: 1,
              showsPercentageHighlight: true
            })}
            title="Maintain ideal exposure"
            subtitle={`in ${categorySipsLabel}`}
            highlightDescription={`Reducing SIP exposure in this fund helps you reach ideal allocation of ${planPercentageLabel({ rawPercentage: idealAllocationAbsolute })} in ${categoryName} as per your strategy.`}
            tone="warning"
          />
        </div>
      </div>
    </div>
  )
}
